export const MENU_TRANSITION_MS = 160
export const MENU_OPEN_EVENT = "elements-menu-open"
export const MENU_CLOSE_EVENT = "elements-menu-close"
